<div class="flex w-full items-center gap-2.5">
  <span
    class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-xs font-semibold text-white"
    [ngClass]="avatarClass()">
    {{ initial() }}
  </span>

  <div class="min-w-0 flex-1">
    <p class="truncate text-sm font-semibold text-slate-950">{{ workspace().name }}</p>
  </div>

  <span class="shrink-0 rounded-full bg-slate-100 px-2.5 py-1 text-xs font-medium text-slate-700">
    {{ roleLabel() }}
  </span>
</div>
